const phase3 = {
  number: 3,
  title: "Race Specific",
  weeks: "Weeks 11–16",
  dates: "Apr 27 – Jun 7",
  color: "#27AE60",
  light: "#EDFAF1",
  accent: "#1A8A47",
  running: "Long runs 8–11 km · Tempo runs added",
  hrTarget: "Easy: Zone 2 ({Z2}) · Tempo: Zone 3 ({Z3})",
  watchAlert: "Long run Sundays — no KB beforehand",
  weekData: [
    {
      week: 11,
      label: "Week 11",
      focus:
        "First tempo run Wednesday. Zone 3 ({Z3}) — hard but controlled. Long run 8 km.",
      days: [
        {
          day: "Mon",
          type: "strength+run",
          workout: "A",
          run: "Easy 5 km — Zone 2",
          note: "Back to 4 runs per week. Fresh start of Phase 3.",
        },
        { day: "Tue", type: "rest", note: "Full rest" },
        {
          day: "Wed",
          type: "strength+run",
          workout: "B",
          run: "Tempo 4 km — Zone 3 ({Z3})",
          note: "Hard day. Strength before tempo. Take Thursday fully off.",
        },
        { day: "Thu", type: "rest", note: "Full rest — recover from Wednesday" },
        {
          day: "Fri",
          type: "strength+run",
          workout: "A",
          run: "Easy 5 km — Zone 2",
          note: "Back to easy. Legs may feel slightly heavy — normal.",
        },
        { day: "Sat", type: "rest", note: "Full rest — prepare for long run" },
        {
          day: "Sun",
          type: "longrun",
          run: "Long run: 8 km — Zone 2 only",
          note: "No KB. First 8 km long run. Should feel manageable after Phase 2 base.",
        },
      ],
    },
    {
      week: 12,
      label: "Week 12",
      focus: "9 km long run. You can smell the finish line from here.",
      days: [
        {
          day: "Mon",
          type: "strength+run",
          workout: "A",
          run: "Easy 5 km — Zone 2",
          note: "Start the week fresh",
        },
        { day: "Tue", type: "rest", note: "Full rest" },
        {
          day: "Wed",
          type: "strength+run",
          workout: "B",
          run: "Tempo 4 km — Zone 3",
          note: "Second tempo. Should feel slightly more comfortable than week 11.",
        },
        { day: "Thu", type: "rest", note: "Full rest" },
        {
          day: "Fri",
          type: "strength+run",
          workout: "A",
          run: "Easy 5–6 km — Zone 2",
          note: "Light increase. Save energy for Sunday.",
        },
        { day: "Sat", type: "rest", note: "Full rest" },
        {
          day: "Sun",
          type: "longrun",
          run: "Long run: 9 km — Zone 2 only",
          note: "9 km. Nearly race distance. Stay fully in Zone 2.",
        },
      ],
    },
    {
      week: 13,
      label: "Week 13",
      focus: "10 km milestone. You can now finish the race. Everything from here is polish.",
      days: [
        {
          day: "Mon",
          type: "strength+run",
          workout: "A",
          run: "Easy 5 km — Zone 2",
          note: "Big week ahead — start conservatively",
        },
        { day: "Tue", type: "rest", note: "Full rest" },
        {
          day: "Wed",
          type: "strength+run",
          workout: "B",
          run: "Tempo 5 km — Zone 3",
          note: "Tempo extended to 5 km. Real race prep.",
        },
        { day: "Thu", type: "rest", note: "Full rest" },
        {
          day: "Fri",
          type: "strength+run",
          workout: "A",
          run: "Easy 5 km — Zone 2",
          note: "Easy before the big milestone run",
        },
        { day: "Sat", type: "rest", note: "Full rest" },
        {
          day: "Sun",
          type: "longrun",
          run: "Long run: 10 km — Zone 2 only",
          note: "10 km milestone. You can now complete the race.",
        },
      ],
    },
    {
      week: 14,
      label: "Week 14",
      focus: "Peak long run — 11 km (beyond race distance). Confidence builder.",
      days: [
        {
          day: "Mon",
          type: "strength+run",
          workout: "A",
          run: "Easy 5 km — Zone 2",
          note: "Peak training week",
        },
        { day: "Tue", type: "rest", note: "Full rest" },
        {
          day: "Wed",
          type: "strength+run",
          workout: "B",
          run: "Tempo 5 km — Zone 3",
          note: "Strong tempo. You know this effort now.",
        },
        { day: "Thu", type: "rest", note: "Full rest" },
        {
          day: "Fri",
          type: "strength+run",
          workout: "A",
          run: "Easy 6 km — Zone 2",
          note: "Slight increase. Legs should feel strong by now.",
        },
        { day: "Sat", type: "rest", note: "Full rest" },
        {
          day: "Sun",
          type: "longrun",
          run: "Long run: 11 km — Zone 2 only",
          note: "11 km — 0.5 km beyond race distance. If you can do this, race day is handled.",
        },
      ],
    },
    {
      week: 15,
      label: "Week 15",
      focus: "Recovery week — reduce volume 20–30%.",
      recovery: true,
      days: [
        {
          day: "Mon",
          type: "strength+run",
          workout: "A",
          run: "Easy 4 km — Zone 2",
          note: "Recovery week — KB sets down to 2",
        },
        { day: "Tue", type: "rest", note: "Full rest" },
        {
          day: "Wed",
          type: "strength+run",
          workout: "B",
          run: "Easy 4 km — Zone 2 (no tempo)",
          note: "No tempo run this week. Pure easy effort.",
        },
        { day: "Thu", type: "rest", note: "Full rest" },
        {
          day: "Fri",
          type: "strength+run",
          workout: "A",
          run: "Easy 4 km — Zone 2",
          note: "Short and easy. Feel the freshness returning.",
        },
        { day: "Sat", type: "rest", note: "Full rest" },
        {
          day: "Sun",
          type: "longrun",
          run: "Long run: 8 km — Zone 2 only",
          note: "Reduced long run. Should feel easier than week 13.",
        },
      ],
    },
    {
      week: 16,
      label: "Week 16",
      focus: "Taper begins. Phase 3 ends. Race is 3 weeks away.",
      days: [
        {
          day: "Mon",
          type: "strength+run",
          workout: "A",
          run: "Easy 4 km — Zone 2",
          note: "Start taper. Less volume, same quality.",
        },
        { day: "Tue", type: "rest", note: "Full rest" },
        {
          day: "Wed",
          type: "strength+run",
          workout: "B",
          run: "Easy 5 km — Zone 2",
          note: "No tempo this week. Fresh legs priority.",
        },
        { day: "Thu", type: "rest", note: "Full rest" },
        {
          day: "Fri",
          type: "strength+run",
          workout: "A",
          run: "Easy 4 km — Zone 2",
          note: "Last heavy Friday of training",
        },
        { day: "Sat", type: "rest", note: "Full rest" },
        {
          day: "Sun",
          type: "longrun",
          run: "Long run: 9 km — Zone 2 only",
          note: "Last proper long run before taper. Phase 4 next.",
        },
      ],
    },
  ],
  workouts: {
    A: {
      name: "Workout A — Power & Running Performance",
      duration: "~35 min",
      exercises: [
        {
          name: "Hip Thrust (elevated)",
          sets: "4 × 12",
          cue: "3-second hold at top. Stronger glutes = faster, more efficient running.",
          muscles: "Glutes",
        },
        {
          name: "KB Swing",
          sets: "4 × 15",
          cue: "Explosive hip snap. This movement mimics your running power output directly.",
          muscles: "Glutes, hamstrings, cardio",
        },
        {
          name: "Romanian Deadlift",
          sets: "3 × 12",
          cue: "Slow eccentric — 4 sec lowering phase. Load those hamstrings properly.",
          muscles: "Hamstrings, glutes",
        },
        {
          name: "KB Row",
          sets: "3 × 12 each",
          cue: "1 sec pause at top. Running posture depends on upper back strength.",
          muscles: "Upper back",
        },
        {
          name: "Dead Bug",
          sets: "3 × 12 each",
          cue: "3-sec hold at full extension. True core control under fatigue.",
          muscles: "Core stability",
        },
        {
          name: "Suitcase Carry",
          sets: "3 × 30 steps each",
          cue: "Longer carries. Perfect posture throughout. This is your race-day core.",
          muscles: "Lateral core, posture",
        },
      ],
    },
    B: {
      name: "Workout B — Stability & Upper Body",
      duration: "~35 min",
      exercises: [
        {
          name: "Goblet Squat (shallow)",
          sets: "3 × 12",
          cue: "2-sec pause at bottom if knees allow. Slightly deeper range than Phase 2.",
          muscles: "Quads, glutes",
        },
        {
          name: "KB Windmill",
          sets: "3 × 6 each",
          cue: "NEW. Press KB overhead. Turn feet 45°. Hinge sideways slowly. Go light first session.",
          muscles: "Obliques, shoulder stability",
          isNew: true,
        },
        {
          name: "Single-Leg Deadlift",
          sets: "3 × 10 each",
          cue: "No support. 1-sec hold at bottom. True balance and body control.",
          muscles: "Glutes, balance",
        },
        {
          name: "KB Press (standing)",
          sets: "3 × 12 each",
          cue: "Strict press — no leg drive. Pause at top.",
          muscles: "Shoulders, core",
        },
        {
          name: "Push-Up",
          sets: "4 × 12",
          cue: "Slow lowering — 3 sec down. Builds chest and protects shoulder.",
          muscles: "Chest, triceps",
        },
        {
          name: "Hip Thrust (elevated)",
          sets: "3 × 15",
          cue: "Higher reps for glute endurance — hold form at km 9.",
          muscles: "Glutes",
        },
      ],
    },
  },
  typeConfig: {
    "strength+run": { bg: "#EDFAF1", border: "#27AE60", label: "KB + Run", dot: "#27AE60" },
    longrun: { bg: "#E3F2FD", border: "#1E88E5", label: "Long Run", dot: "#1E88E5" },
    rest: { bg: "#F5F5F5", border: "#CCCCCC", label: "Rest", dot: "#BBBBBB" },
  },
};

export default phase3;
